
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral/join",
      function () {
        return require("private-next-pages/referral/join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral/join"])
      });
    }
  